
/**
 * @export
 * @enum {string}
 */
export enum SectionType {
    CUSTOM = 'CUSTOM',
    SEARCH = 'SEARCH'
}